export default "__VITE_ASSET__CKSoqM$D__"